import React from 'react';

function LoadingScreen() {
    return (
        <div className="ls-overlay">
            {/* SVG gradient definition — referenced by ls-ring-fill stroke */}
            <svg width="0" height="0" style={{ position: 'absolute' }}>
                <defs>
                    <linearGradient id="ls-grad" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#ff8b7a" />
                        <stop offset="100%" stopColor="#a02018" />
                    </linearGradient>
                </defs>
            </svg>
            <div className="ls-card">
                <div className="ls-logo-ring">
                    <svg className="ls-ring-svg" viewBox="0 0 80 80">
                        <circle className="ls-ring-track" cx="40" cy="40" r="34" />
                        <circle className="ls-ring-fill" cx="40" cy="40" r="34" />
                    </svg>
                    <div className="ls-logo-inner">
                        <span className="ls-logo-cs">C&amp;S</span>
                    </div>
                </div>
                <div className="ls-brand">C&amp;S EVENTS PPV</div>
                <div className="ls-bar-wrap">
                    <div className="ls-bar" />
                </div>
                <div className="ls-hint">กำลังโหลด...</div>
            </div>
        </div>
    );
}

export default LoadingScreen;
